<template>
  <div>
    <p v-if="bills.length === 0">
      {{ noResultsText }}
    </p>
    <div v-else>
      <p v-if="descriptionText">
        {{ descriptionText }}
      </p>
      <RecruiterBillsTable :bills="bills" :preferred-rate-type="preferredRateType" />
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from 'vue'
import RecruiterBillsTable from '@/components/RecruiterBills/RecruiterBillsTable.vue'

const props = defineProps({
  bills: {
    type: Array,
    default: () => [],
  },
  preferredRateType: {
    type: String,
    required: true,
  },
  noResultsText: {
    type: String,
    default: '',
  },
  descriptionText: {
    type: String,
    default: '',
  },
})
</script>
